module.exports = __webpack_public_path__ + "img/jdEk.ac62e50f.png";